import { Component } from 'react';
import { createPortal } from 'react-dom';
const canUseDOM = typeof window !== 'undefined' &&
    !!window.document &&
    !!window.document.createElement;
export class Portal extends Component {
    constructor() {
        super(...arguments);
        this.defaultNode = null;
    }
    componentWillUnmount() {
        if (this.defaultNode) {
            document.body.removeChild(this.defaultNode);
        }
        this.defaultNode = null;
    }
    render() {
        if (!canUseDOM) {
            return null;
        }
        const { children, node } = this.props;
        if (!node && !this.defaultNode) {
            this.defaultNode = document.createElement('div');
            document.body.appendChild(this.defaultNode);
        }
        return createPortal(children, node || this.defaultNode);
    }
}
//# sourceMappingURL=Portal.js.map